import { useRef, useState, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
//Components
import {
    Grid,
    Typography,
    Container,
    Paper,
    Divider,
    Chip
} from "@mui/material";

import { Button } from "@gpstrackit/react-controls";
import DataViewInfiniteScroll from 'Components/DataViewInfiniteScroll';
import ChipStatus from 'Components/ChipStatus';
import { Tooltip } from "@gpstrackit/react-controls";

import {
    tagsOpenCreateEdit,
    //tagsGetUserRequest,
    tagsOpenCloseDeleteTagsModal,
    generalCatalogInitial

} from 'Redux/actions';

//Helpers
import { getDateFormatted, idsValidation } from 'Core/data/Helpers';

//Views
import CreateEditTag from 'Modules/tags/.components/createEditTag';
import DeleteTags from 'Modules/tags/.components/deleteTag';


//Notification
import { NotificationManager } from "Components/Notifications";

//Permission
import { HasPermission } from "Core/security"
import { de } from "date-fns/locale";

const PMTags = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const tableRef = useRef();

    const createEditTagOpenModal = useSelector(state => state.createEditTagRedux.openCreateEdit);
    const deleteTagsOpenModal = useSelector(state => state.deleteTagsRedux.open);


    //Local states
    const [total, setTotal] = useState(0);
    const [columns, setColumns] = useState([
        {
            key: "label",
            field: "label",
            title: messages['pmtags_main_label'],
            width: 200,
            show: true,
            sort: true,
            locked: true,
            resize: true,
            export: true,
            functionString: 'return `${row?.label}`;',
            code: "pmtags_main_label",
            render: (item) => {
                return <div style={{ width: 210, height: 25 }}>
                    <Chip style={{ backgroundColor: item?.color ? `#${item.color}` : "#000000", color: "#FFFFFF" }} label={item.label || ''}></Chip>
                </div>
            }
        },
        {
            key: "companies",
            field: "companiesCount",
            title: messages['pmtags_main_accounts'],
            width: 200,
            show: true,
            locked: true,
            resize: true,
            export: true,
            functionString: 'return row?.companiesCount',
            code: "pmtags_main_accounts",
            render: (item) => {
                return <span>{item?.companiesCount || 0}</span>
            }
        },
        {
            key: "devices",
            field: "unitsCount",
            title: messages['pmtags_main_devices'],
            width: 200,
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.unitsCount',
            code: "pmtags_main_devices",
            render: (item) => {
                return <span>{item?.unitsCount || 0}</span>
            }
        },

    ])
    const [searchFields, setSearchFields] = useState(["label"]);

    const user = useSelector(state => state.securityRedux.user);

    const reloadTGrid = () => {
        tableRef?.current?.getData({});
    }

    useEffect(() => {
       //dispatch(generalCatalogInitial());
    }, []);

    // ═══════════════════════════════════════════════════════════════════════════
    // DATAVIEWINFINITESCROLL CONFIGURATION
    // Extracted from JSX for readability (per MIGRATION-GUIDE-FOR-AI.md STEP 7B)
    // ═══════════════════════════════════════════════════════════════════════════

    /**
     * GraphQL configuration for searchTags query
     */
    const graphqlConfig = useMemo(() => ({
        function: "searchTags",
        sortType: "TagSortInput",
        conditionsType: "TagSearchInput",
        customQuery: "id color",
        dynamicQuery: true,
    }), []);

    /**
     * Search bar configuration
     */
    const searchConfig = useMemo(() => ({
        fields: ["label"],
        optionValue: "id",
        optionLabel: "label",
    }), []);

    /**
     * Export configuration
     */
    const exportConfig = useMemo(() => ({
        fileName: "pmtags",
    }), []);

    /**
     * UI/Layout configuration
     */
    const uiConfig = useMemo(() => ({
        hideSplit: true,
        hideFilters: true,
        topHeight: 210,
    }), []);

    /**
     * Handle condition changes from search/filters
     */
    const handleChangeConditions = (tags, conditions, total, newColumns, rows, sort, key, fromPreferences, restoreOnly) => {
        // restoreOnly: data already persisted in redux, just sync UI states — skip getData
        if (restoreOnly) return;

        let currentConditions = {}
        let currentTags = {}
        if (!conditions && tags) {
            currentConditions = tableRef?.current?.conditions;
            currentTags = tags;
        } else {
            currentConditions = conditions || [];
            currentTags = currentConditions?.filter((x) => x?.tags)[0]?.tags || [];
            if (currentTags && currentTags.length > 0) tableRef?.current?.setTags(currentTags);
        }

        currentConditions = currentConditions?.filter((item) => item?.fields[0] !== 'id' && item?.fields[0] !== 'label');

        let tagsById = currentTags.filter((item) => typeof item.id === "number");
        if (tagsById?.length > 0) {
            //New Items
            let currentIds = tagsById.map((item) => (item.id));
            if (currentIds.length > 0) {
                currentConditions.push({ fields: ["id"], terms: currentIds, exact: true, tags: currentTags, conditionOperator: "OR" });
            }
        }
        let tagsByLabel = currentTags.filter(item => typeof item.id === "string")
        if (tagsByLabel.length > 0) {
            let currentLabels = tagsByLabel.map((item) => (item.label))
            if (currentLabels.length > 0) {
                currentConditions.push({ fields: searchFields, terms: currentLabels, exact: false, tags: currentTags, conditionOperator: "OR" })
            }
        }

        if (!conditions && tags) {
            tableRef?.current?.getData({ newConditions: currentConditions, newColumns: newColumns });
        } else {
            tableRef?.current?.getData({ newRows: rows, newSort: sort, newConditions: currentConditions });
        }
    };

    /**
     * Context menu options for row actions
     */
    const menuOptions = useMemo(() => [
        {
            id: "edit-tag",
            single: true,
            label: messages['pmtags_main_edit_tag'],
            show: true,
            disabled: !HasPermission(user, "pmtag", "u"),
            action: (items) => {
                let currentItem = items.find(item => item.id);
                if (currentItem.id) {
                    dispatch(tagsOpenCreateEdit(currentItem.id));
                }
            }
        },
        {
            id: "delete-tag",
            multiple: true,
            label: messages['pmtags_main_delete_tag'],
            show: true,
            disabled: !HasPermission(user, "pmtag", "d"),
            action: (items) => {
                dispatch(tagsOpenCloseDeleteTagsModal(true, items));
            }
        }
    ], [messages, user, dispatch]);

    /**
     * Row menu options renderer
     */
    const renderMenuOptions = () => {
        return [
            messages['edit'],
            messages['delete']
        ];
    };

    /**
     * Handle row menu click
     */
    const handleClickMenu = (event, item) => {
        if (event === messages['edit']) {
            if (HasPermission(user, "pmtag", "u")) {
                dispatch(tagsOpenCreateEdit(true, item.id));
            } else {
                NotificationManager.warning(
                    messages['common_error_permission'],
                    messages['edit'],
                    3000,
                );
            }
        }
        if (event === messages['delete']) {
            if (HasPermission(user, "pmtag", "d")) {
                dispatch(tagsOpenCloseDeleteTagsModal(true, [item]))
            } else {
                NotificationManager.warning(
                    messages['common_error_permission'],
                    messages['delete'],
                    3000,
                );
            }
        }
    };

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" gutterBottom component="div">
                            {messages['pmtags_main_title']} {/* ({total}) */}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className="main-view-buttons">
                        <Button
                            disabled={!HasPermission(user, "pmtag", "c")}
                            className="btn-dark-blue"
                            onClick={(e) => {
                                e.preventDefault();
                                dispatch(tagsOpenCreateEdit(true));
                            }}
                        >
                            {messages['pmtags_main_add_tag']}
                        </Button>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataViewInfiniteScroll
                        ref={tableRef}
                        name="pm-tags-main"
                        entity="pmtags"
                        columns={columns}
                        infiniteScroll
                        clearOnUnmount={false}
                        graphqlConfig={graphqlConfig}
                        searchConfig={searchConfig}
                        exportConfig={exportConfig}
                        uiConfig={uiConfig}
                        onChangeColumns={(items) => setColumns(items)}
                        onChangeConditions={handleChangeConditions}
                        searchFields={searchFields}
                        tableButtons={["export", 'orderColumn']}
                        options={menuOptions}
                        onChangeTotal={(total) => setTotal(total)}
                        menuOptions={renderMenuOptions}
                        onClickMenu={handleClickMenu}
                    />
                </Grid>
            </Paper>
            {createEditTagOpenModal && <CreateEditTag callback={reloadTGrid} />}
            {deleteTagsOpenModal && <DeleteTags callback={reloadTGrid} />}

        </Container>
    )
}
export default PMTags;